<template>
  <at-modal
    v-model="showMe"
    :showFooter="false"
    title="Викторина"
    :styles="{ maxWidth: '100vw' }"
  >
    <div class="maindiv">
      <p class="searchitem__body" style="text-align: center; font-size: 110%">
        Раздел в разработке. Скоро здесь появится викторина по словарю.<br />
        <img
          src="/static/lang/img/sov1.png"
          style="padding: 10px; width: 200px"
        />
      </p>
    </div>
  </at-modal>
</template>

<script>
export default {
  data: () => ({
    showMe: true,
  }),
  watch: {
    showMe() {
      if (!this.showMe) this.$router.push({ path: "/" });
    },
  },
};
</script>

<style scoped>
p {
  text-align: justify;
  font-size: 120% !important;
  margin: 6px;
}

.maindiv {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  overflow-x: hidden;
}

.searchitem__body {
  margin-bottom: 0; 
  max-height: 50vh; 
  overflow-y: auto;
}

@media (max-width: 576px) {
  .maindiv {
    height: calc(100vh - 130px);
    min-height: calc(100vh - 130px);
  }
}
</style>